<div>
  <h1 class="nav-button">
    <ng-content></ng-content>
  </h1>
</div>
